export default {
  CONFIRM_PASSWORD: 'Confirmar contraseña',
  FORGOT_PASSWORD_CAPTION:
    'No se preocupe. Introduzca nombre de usuario y le enviaremos un enlace para restablecer dirección de correo registrada.',
  PASSWORD_EMAIL_SUCCESS: 'Se ha enviado una nueva contraseña a su correo registrado.',
  SENT_EMAIL_TITLE: 'Nueva contraseña enviada',
  INVALID_RESET_PASS_LINK: 'Parece que el enlace para restablecer la contraseña no es válido. Intente de nuevo.',
  RESET_PASS_SUCCESS: 'Su contraseña se ha restablecido correctamente, inicie sesión.',
  RESET_PASS_LINK_EXPIRED: 'Parece que el enlace para restablecer la contraseña ha caducado. Inténtelo de nuevo.',
  PASSWORDS_NOT_SAME: 'La contraseña y la contraseña de confirmación deben ser las mismas',
  RESET_PASSWORD: 'Restablecer contraseña',
  RESET_PASSWORD_CAPTION: 'Introduzca nueva contraseña y haga clic en el botón Enviar.'
}
